import { IndexPath, SettingsTabsEnum } from '@/Config/app/router/index.path';
import { getCurrentScenarioId } from '@/context';

// FAQ accordion item value (see PricingFaq FAQ_KEYS) + its anchor id; the billing page opens
// and scrolls to it when the URL hash matches. Kept here so the credits cards and the FAQ agree.
export const AI_CREDITS_FAQ_KEY = 'ai_credits';

// Built at click time, NOT at import: the module-level SCENARIO_ID is resolved once at load and is
// stale/empty when the app boots off a non-scenario route or the user switches bots (SPA).
// Full `/i/<scenario>/...` path (basename is NOT auto-applied to navigate() here) — mirrors the
// working UpgradePlanButton navigation exactly, so it resolves from sidebar, topbar, or billing.
export const buildAiCreditsFaqPath = (): string =>
  `/i/${getCurrentScenarioId()}/${IndexPath.settings}?tab=${SettingsTabsEnum.Billing}#faq-${AI_CREDITS_FAQ_KEY}`;
